import { ModelBase } from "@shoothill/core";
import { makeObservable, observable } from "mobx";
import { Validator } from "Application/Validation";

export class StagesModel extends ModelBase<StagesModel> {
    public status: string = "";
    public title: string = "";
    public description: string = "";
    public stageDateUTC: null | Date = null;
    public number: number = 0;
    public isCompleted: boolean = false;
    public isVisible: boolean = false;

    constructor() {
        super();
        makeObservable(this, {
            status: observable,
            title: observable,
            description: observable,
            stageDateUTC: observable,
            number: observable,
            isCompleted: observable,
            isVisible: observable,
        });
    }
}

export class StagesModelValidator extends Validator<StagesModel> {
    constructor() {
        super();
    }
}
